import { useQuery } from "@tanstack/react-query";
import { queryClient } from "../../lib/queryClient";
import { queryKeys } from "../../lib/queryKeys";
import {
  getProviderDetails,
  getStatusList,
  getTopicList,
} from "../../services";

const REFERENCE_DATA_STALE_TIME = 5 * 60 * 1000;

export const fetchStatusListQuery = () =>
  queryClient.fetchQuery({
    queryKey: queryKeys.statusList(),
    queryFn: () => getStatusList(),
    staleTime: REFERENCE_DATA_STALE_TIME,
  });

export const fetchTopicListQuery = () =>
  queryClient.fetchQuery({
    queryKey: queryKeys.topicList(),
    queryFn: () => getTopicList(),
    staleTime: REFERENCE_DATA_STALE_TIME,
  });

export const useStatusList = (enabled = true) =>
  useQuery({
    queryKey: queryKeys.statusList(),
    queryFn: () => getStatusList(),
    enabled,
    staleTime: REFERENCE_DATA_STALE_TIME,
  });

export const useTopicList = (enabled = true) =>
  useQuery({
    queryKey: queryKeys.topicList(),
    queryFn: () => getTopicList(),
    enabled,
    staleTime: REFERENCE_DATA_STALE_TIME,
  });

export const useProviderDetails = (providerNpi?: string) =>
  useQuery({
    queryKey: queryKeys.providerDetails(providerNpi ?? ""),
    queryFn: () =>
      getProviderDetails({ provider_npi: providerNpi! }),
    enabled: Boolean(providerNpi),
    staleTime: REFERENCE_DATA_STALE_TIME,
  });
